<template>
  <div class="flex-grow-1 p-2">
    <TranslationsManager
      :value="value"
      @input="newVal => $emit('input', newVal)"
    
      empty-state-title="Dit product heeft geen vertalingen"
    />
  </div>
</template>

<script>

import TranslationsManager from "../../../../layout/TranslationsManager/TranslationsManager.vue"

export default {
  components: {
    TranslationsManager,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
}

</script>

<style scoped>


</style>
